import type React from 'react';
import { useEffect, useRef } from 'react';
import { IconSearch } from '../Icon';
import Loader from '../Loader';
import { Icon, Input, Search } from './wrapper';

type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

type InputSearchProps = InputProps & {
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  loading?: boolean;
};

const QuickMenuSearch = ({
  placeholder,
  value,
  disabled,
  loading,
  onChange,
  onKeyDown,
}: InputSearchProps) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    ref.current?.focus();
  }, [ref, ref.current]);

  return (
    <Search>
      <Icon htmlFor="quick-menu-search-input">
        {loading ? <Loader inlineBlock /> : <IconSearch />}
      </Icon>
      <Input
        ref={ref}
        placeholder={placeholder}
        name="search"
        value={value}
        id="quick-menu-search-input"
        disabled={disabled}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
    </Search>
  );
};

export default QuickMenuSearch;
